import { AnbAuthGuard } from '@anb/ng-auth';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ROUTE } from 'app/modules/_core/services/route.service';
import { Error403Component } from './pages/error403/error403.component';
import { Error451Component } from './pages/error451/error451.component';
import { OverzichtComponent } from './pages/overzicht/overzicht.component';
import { WelkomComponent } from './pages/welkom/welkom.component';

// Routing for main application
const appRoutes: Routes = [
  {
    path: ROUTE.HOME,
    component: WelkomComponent,
  },
  {
    path: ROUTE.OVERZICHT,
    component: OverzichtComponent,
    canActivate: [AnbAuthGuard],
  },
  {
    path: ROUTE.ERROR403,
    component: Error403Component,
  },
  {
    path: ROUTE.ERROR451,
    component: Error451Component,
  },
  {
    path: ROUTE.AANVRAAG,
    loadChildren: () => import('./modules/aanvraag/aanvraag.module').then((mod) => mod.AanvraagModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { enableTracing: false })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
